// removed by extract-text-webpack-plugin
module.exports = {"containerClass":"styles__containerClass___3x7RX"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/NewInterfaceOnline/components/DescriptionList/styles.css
// module id = 2870
// module chunks = 0